<template>
  <section class="leftService">
    <a :href="url + '?admin=false'">
      <img src="https://static.iyw.cn/logo/appAbout.png" class="logo" alt="" />
    </a>
    <p class="p_1">创意和版权赋能中国制造</p>
    <p>的数智化平台</p>
    <ul class="serve">
      <li>流行趋势创意，激发畅销灵感</li>
      <li>产品设计实现，快速生成新品</li>
      <li>成果保护交易，护航创意资产</li>
    </ul>
  </section>
</template>

<script>
export default {
  data() {
    return {
      url: process.env.VUE_APP_PORTAL
    }
  }
};
</script>

<style lang="scss">
.leftService {
  width: 460px;
  height: 100%;
  background-image: url(../../../assets/img/left.png);
  background-size: cover;
  .logo {
    width: 156px;
    height: auto;
    margin: 43px 0 0 68px;
  }
  p {
    font-size: 32px;
    font-weight: 600;
    color: #222222;
    line-height: 56px;
    margin-left: 72px;
  }
  .p_1 {
    margin-top: 148px;
  }
  .serve {
    padding: 36px 0 0 68px;
    li {
      color: $textColor;
      margin-bottom: 32px;
      &::before {
        content: '';
        display: inline-block;
        width: 17px;
        height: 17px;
        background: url('../../../assets/img/icon.png') no-repeat;
        background-size: 100%;
        margin-right: 16px;
      }
    }
  }
}
</style>
